import View from './View'
import CloseButton from './CloseButton'
import { createSVGLogo, getScreenRatio } from './helpers/DOMHelper'
import { easeInWord } from './helpers/EaseHelper'

export const STATE_INIT = 'about--init'
export const STATE_INTRO = 'about--intro'
export const STATE_OUTRO = 'about--outro'

/**
 * class About
 */
class About extends View {
  /**
   * constructor
   */
  constructor (el) {
    super(el)
    this.state = STATE_INIT
    this.closeButton = new CloseButton(this.view.querySelector('.about__close'))
    this.logo = createSVGLogo(this.view.querySelector('.about__logo'), 'about')
    this.letters = this.logo.letters
    this.letters.map(letter => letter.style.opacity = 0)
    this.lettersTimeout = null
    this.isOpen = false
  }

  showHandler (resolve) {

    this.isOpen = true
    this.state = STATE_INTRO

    setTimeout(resolve, 1000)

    this.letters.map(letter => {
      letter.style.opacity = 0
      return letter
    })

    this.lettersTimeout = setTimeout(() => {
      this.letters.map(letter => {
        easeInWord(letter, ()=>{}, null, 3000)
        return letter
      })
    }, 1200)

    setTimeout(() => {
      this.closeButton.view.addEventListener('click', this.close)
      this.closeButton.show()
    }, 800)
  }

  hideHandler (resolve) {
    clearTimeout(this.lettersTimeout)
    this.state = STATE_INIT
    this.isOpen = false
    resolve()
  }

  close = () => {
    this.state = STATE_OUTRO
    this.closeButton.hide()
    this.closeButton.view.removeEventListener('click', this.close)
    setTimeout(() => this.hide(), 900)
  }

  update (time, delta) {
    this.logo.svg.style.transform = `scale3d(${1. * getScreenRatio()}, ${1. * getScreenRatio()}, 1)`
  }
}
export default About


// WEBPACK FOOTER //
// ./src/scripts/About.js